import { commerceFacetSetReducer as commerceFacetSet } from '../facet-set/facet-set-slice.js';
import { toggleExcludeNumericFacetValue, toggleSelectNumericFacetValue, updateNumericFacetValues, } from './numeric-facet-actions.js';
/**
 * Loads the commerce facet set reducer and returns the available numeric facet action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the numeric facet action creators.
 *
 * @group Actions
 * @category NumericFacet
 */
export function loadNumericFacetActions(engine) {
    engine.addReducers({ commerceFacetSet });
    return {
        toggleSelectNumericFacetValue,
        toggleExcludeNumericFacetValue,
        updateNumericFacetValues,
    };
}
